import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, computed, inject, signal } from '@angular/core';
import { AbstractControl, FormControlStatus } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { FormErrorService } from '../../../services/form-error.service';

@Component({
  selector: 'app-input-field-error',
  templateUrl: './input-field-error.component.html',
  styleUrls: ['./input-field-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class InputFieldErrorComponent implements OnInit, OnDestroy {
  public formErrors = inject(FormErrorService);
  @Input() control: AbstractControl;
  @Input() rounded = false;
  showError = signal(false);
  destroyed$ = new Subject<void>();
  controlStatus = signal<FormControlStatus>(undefined);
  error = computed(() => (this.controlStatus() === 'INVALID' ? this.formErrors.getFieldError(this.control) : null));

  ngOnInit() {
    this.controlStatus.set(this.control.status);
    this.control.statusChanges.pipe(takeUntil(this.destroyed$)).subscribe(status => this.controlStatus.set(status));
    this.showError.set(true);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
